<template>
    <div class="home-nav">
        <div class="nav-box" v-if="navShow">
            <div class="nav-left">
                <img @click="toHome()" class="nav-left-icon" :src="iconLogo" alt="">
                <div class="nav-row">
                    <!--:class="{'nav-row-list-ac': tabNumber == index ,'border-line': index == 4}"-->
                    <div class="nav-row-list"
                         :class="{'nav-row-list-ac': tabNumber == index}"
                         v-for="(item,index) in navList"
                         :key="index"
                         @click="tabClick(index,item.id,item.idSmall)">
                        {{ item.text }}
                    </div>
                </div>
            </div>

            <div class="nav-right">
                <el-autocomplete
                        v-show="showInput"
                        v-model="state"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入内容"
                        @select="handleSelect"
                        :value="search"
                >
                    <i class="el-icon-search el-input__icon"
                       style="color: #FF5227;cursor: pointer;"
                       slot="suffix"
                       @click="handleIconClick">
                    </i>
                </el-autocomplete>
            </div>
        </div>

        <div class="nav-box" v-else>
            <div class="nav-left">
                <img @click="toHome()" class="nav-left-icon" :src="iconLogo" alt="">
                <div class="nav-person">
                    <span>{{isLogin ? '欢迎登陆' : '个人中心首页' }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "homeNav",
        props: {
            showInput: {
                type: Boolean,
                default: true,
            }
        },
        data() {
            return {
                navShow: false,
                iconLogo: require('@/assets/images/index/nav_img_logo.png'),
                navList: [
                    {
                        text: '首页',
                        id: 'Home',
                        idSmall: 'home'
                    },
                    {
                        text: '我要包车',
                        id: 'Charter',
                        idSmall: 'charter'
                    },
                    {
                        text: '自动报价',
                        id: 'Offer',
                        idSmall: 'offer'
                    },
                    {
                        text: '文章资讯',
                        id: 'Information',
                        idSmall: 'information'
                    },
                    {
                        text: '司机入驻',
                        id: 'Join',
                        idSmall: 'join'
                    },
                    /*{
                        text: '定制旅游',
                        id: 'Travel',
                        idSmall: 'travel'
                    },*/
                    {
                        text: '关于我们',
                        id: 'About',
                        idSmall: 'about'
                    }
                ],
                tabNumber: 0,
                // 搜索框
                restaurants: [],
                state: '',
                timeout: null,
                isLogin: false,
                search: ''
            }
        },

        methods: {
            toHome() {
                var curPath = this.$route.path;
                if (curPath.search('/home') != -1) {
                    return;
                } else {
                    this.$router.push({path: '/home'});
                }
            },
            tabClick(index, id, idSmall) {
                var that = this;
                that.tabNumber = index;
                var currentUrl = this.$route.path;
                if (currentUrl.search(idSmall) != -1) {
                    if (currentUrl.search('charterDetails') != -1 || currentUrl.search('informationDetails') != -1) {
                        this.$router.push({name: id});
                    } else {
                        return;
                    }
                    return;
                } else {
                    this.$router.push({name: id});
                }
            },
            loadAll() {
                return [
                    // {"value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号"},
                    // {"value": "Hot honey 首尔炸鸡（仙霞路）", "address": "上海市长宁区淞虹路661号"},
                ];
            },
            querySearchAsync(queryString, cb) {
                // console.log(queryString, cb);
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
                cb(results);
                // clearTimeout(this.timeout);
                // this.timeout = setTimeout(() => {
                //     cb(results);
                // }, 1000 * Math.random());
            },
            createStateFilter(queryString) {
                return (state) => {
                    return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect(item) {
                console.log(item);
            },

            handleIconClick(ev) {
                this.$router.push({path: "/charter", query: {search: this.state}});
            },

            fetchDate() {
                if (
                    this.$route.name === 'Persondata'
                    || this.$route.name === 'Persondatahome'
                    || this.$route.name === 'Orderdetail'
                    || this.$route.name === 'Travelorder'
                    || this.$route.name === 'Collection'
                    || this.$route.name === 'Travelcol'
                    || this.$route.name === 'Individual'
                    || this.$route.name === 'Invoice'
                    || this.$route.name === 'Evaluate'
                    || this.$route.name === 'Complaint'
                    || this.$route.name === 'Binding'
                    || this.$route.name === 'Modify'
                    || this.$route.name === 'Orderparticulars'
                    || this.$route.name === 'Login'
                ) {
                    this.navShow = false;
                    if (this.$route.name === 'Login') {
                        this.isLogin = true;
                    } else {
                        this.isLogin = false;
                    }
                } else {
                    this.navShow = true;
                }
            },
        },
        mounted() {
            this.getUrlCurrent();
            this.restaurants = this.loadAll();
        },
        created() {
            if (
                this.$route.name === 'Persondata'
                || this.$route.name === 'Persondatahome'
                || this.$route.name === 'Orderdetail'
                || this.$route.name === 'Travelorder'
                || this.$route.name === 'Collection'
                || this.$route.name === 'Travelcol'
                || this.$route.name === 'Individual'
                || this.$route.name === 'Invoice'
                || this.$route.name === 'Evaluate'
                || this.$route.name === 'Complaint'
                || this.$route.name === 'Binding'
                || this.$route.name === 'Modify'
                || this.$route.name === 'Orderparticulars'
                || this.$route.name === 'Login'
            ) {
                this.navShow = false;
                if (this.$route.name === 'Login') {
                    this.isLogin = true;
                } else {
                    this.isLogin = false;
                }
            } else {
                this.navShow = true;
            }
        },
        watch: {
            // 如果路由有变化，会再次执行该方法
            "$route": "fetchDate",
        }
    }
</script>

<style scoped>
    .home-nav {
        width: 100%;
        min-width: 1200px;
        height: 84px;
        background: #fff;
    }

    .nav-box {
        width: 1200px;
        height: 84px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .nav-left {
        display: flex;
        flex: 1;
        align-items: center;
    }

    .nav-left-icon {
        width: 134px;
        height: 44px;
        margin-right: 8px;
    }

    .nav-row {
        margin-left: 110px;
        height: 84px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .nav-row-list {
        min-width: 60px;
        height: 60px;
        line-height: 64px;
        padding: 0 10px;
        text-align: center;
        position: relative;
        font-size: 16px;
        cursor: pointer;
        color: #333;
    }

    .nav-row-list-ac {
        color: #FF5227;
    }

    .nav-row-list-ac:after {
        display: block;
        content: '';
        width: 40px;
        height: 2px;
        background: #FF5227;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -20px;
    }

    .border-line {
        border-right: 1px solid #FF5227;
    }

    .nav-right {
        height: 84px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    /*个人中心顶部*/
    .nav-person {
        margin-left: 43px;
        height: 50px;
        border-left: 1px solid #E5E5E5;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .nav-person span {
        margin-left: 43px;
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
</style>



// WEBPACK FOOTER //
// src/components/homeNav.vue